<!--制造差异BOM-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form
        class="manufacture-search-form"
        @search="onSearch"
        @reset="resetQuery"
        :formList="formList"
        ref="refSearchForm">
        <global-select
          slot="organizationCode"
          :value.sync="queryParams.organizationCode"
          selectType="selectAssembleFilter"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button v-hasPermi="['mdm:mbomBillStructures:diffApply:diff']" type="primary" :loading="loading" @click="onHandleDifference">与PBOM差异处理</a-button>
        <a-button v-hasPermi="['mdm:mbomBillStructures:diffBatch']" type="primary" :loading="loading" @click="onBatchDifference">批量处理差异</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :expandIconColumnIndex="2"
          :expanded-row-keys.sync="expandedRowKeys"
          rowKey="id"
          :selectedRows.sync="selectedRows"
          :custom-selection="selectionConfig"
          :multi-select="true"
          @selectedRowChange="selectedRowChange"
          @successCallBack="successCallBack"
          :scroll="{ fixScreen: true, x: 1800 }">
          <template #itemCodeHeader>
             <span class="item-code-header">
               <a-icon
                 :type="allExpanded ? 'minus-square' : 'plus-square'"
                 class="expand-toggle-icon"
                 @click="toggleExpandAll"
               />
              <span>物料编码</span>
            </span>
          </template>
          <template #operation="{ record }">
            <a v-hasPermi="['mdm:mbomBillStructures:log:diff']" @click="() => handleLog(record)">日志</a>
          </template>
        </ls-api-table>
        <updateModal ref="updateModalRef" @refresh="() => handleOk(true)" />
        <difference-modal ref="differenceModalRef" @refresh="() => handleOk(true)" @update="onUpdate"/>
        <batch-difference-modal ref="batchDifferenceModalRef" @refresh="() => handleOk(true)" />
        <operation-log-model ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import cacheSearch from '@/mixins/cacheSearch'
import differenceModal from '@/views/mdm/matter/manufactureMbom/components/difference-modal.vue'
import BatchDifferenceModal from '@/views/mdm/matter/manufactureMbom/components/batch-difference-modal.vue'
import { apiMbomBillStructuresList, apiMbomBillStructuresLogList } from '@/api/mdm/matter/manufacture-mbom.js'
import updateModal from '@/views/mdm/matter/manufactureMbom/components/update-modal.vue'
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'
import { mapState } from 'vuex';
import { columns } from '@/views/mdm/matter/manufactureMbom/enum'

export default {
  name: 'ManufactureDiffBom',
  components: { differenceModal, BatchDifferenceModal, OperationLogModel, updateModal },
  mixins: [cacheSearch],
  data() {
    return {
      loading: false,
      logLoading: false,
      logList: [],
      selectedRowKeys: [],
      selectedRows: [],
      expandedRowKeys: [],
      allExpanded: false,
      tableProps: {
        requestApi: generateLsTableResData(apiMbomBillStructuresList, false),
        pageCurrent: true
      },
      dataList: [],
      firstLevelIds: [],
      queryParams: {
        organizationCode: undefined,
        itemCode: undefined,
        itemCodes: undefined,
        mbomVersion: undefined,
        pbomVersion: undefined,
        itemName: undefined
      },
      formList: [
        { label: '库存组织', decorator: ['organizationCode'], type: 'organizationCode' },
        { label: '物料编码', decorator: ['itemCode'], type: 'input' },
        { label: 'MBOM版本号', decorator: ['mbomVersion'], type: 'input' },
        { label: '来源PBOM版本号', decorator: ['pbomVersion'], type: 'input' },
        { label: '物料名称', decorator: ['itemName'], type: 'input' }
      ],
      columns: columns,
      selectionConfig: {
        getCheckboxProps: record => {
          return {
            props: {
              disabled: !this.firstLevelIds.includes(record.id)
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  mounted() {
    this.firstLevelIds = [];
    this.loading = false;
    this.initPageSearch()
  },
  methods: {
    // 兼容处理excel复制的处理，去掉空格，整合成list
    onChangeCopyFormExcel(params, valField, listField) {
      const listVal = []
      if (params[valField]) {
        const list = params[valField].split(' ')
        list.forEach((v, i) => {
          list[i] = v.replace(/[\n\r\s]+/g, '')
          if (list[i]) { listVal.push(list[i]) }
        })
      }
      params[listField] = listVal
    },
    getRouteSearchParams() {
      const routeParams = { ...(this.$route.query || {}) }
      const searchKeys = Object.keys(this.queryParams)
      const searchValues = {}
      searchKeys.forEach(key => {
        const value = routeParams[key]
        if (value !== undefined && value !== null && value !== '') {
          searchValues[key] = value
        }
      })
      return searchValues
    },
    applyRouteSearchParams() {
      const searchValues = this.getRouteSearchParams()
      if (!Object.keys(searchValues).length) {
        return false
      }
      if(searchValues.itemCodes) {
        searchValues.itemCode = searchValues.itemCodes
      }
      Object.assign(this.queryParams, searchValues)
      if (this.$refs.refSearchForm && this.$refs.refSearchForm.form) {
        this.$refs.refSearchForm.form.setFieldsValue(searchValues)
      }
      return true
    },
    initPageSearch() {
      this.$nextTick(() => {
        this.applyRouteSearchParams()
        this.onSearch()
      })
    },
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    handleLog(row) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show()
      apiMbomBillStructuresLogList({ orderId: row.id }).then(res => {
        if (res?.code === 200 && res?.rows?.length > 0) {
          res.rows.forEach(item => {
            item.logInfo = item.log
          })
          this.logList = res.rows
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    successCallBack(data) {
      this.dataList = data || [];
      this.firstLevelIds = data.map(item => item.id);
      this.expandedRowKeys = [];
      this.allExpanded = false;
    },
    collectExpandedKeys(treeList = [], keys = []) {
      if (!Array.isArray(treeList) || !treeList.length) {
        return keys;
      }
      treeList.forEach(item => {
        if (Array.isArray(item.children) && item.children.length > 0) {
          if (item.id !== undefined && item.id !== null) {
            keys.push(item.id);
          }
          this.collectExpandedKeys(item.children, keys);
        }
      });
      return keys;
    },
    toggleExpandAll() {
      if (this.allExpanded) {
        this.expandedRowKeys = [];
        this.allExpanded = false;
        return;
      }
      this.expandedRowKeys = this.collectExpandedKeys(this.dataList, []);
      this.allExpanded = true;
    },
    // 更新
    onUpdate() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      if(this.selectedRows?.length > 1) {
        return this.$message.warning("请勾选一条单据进行操作")
      }
      const getDafultRow = this.dataList.find(item => item.id === this.selectedRows[0].id)
      this.$refs.updateModalRef.show(getDafultRow)
    },
    onHandleDifference() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      if(this.selectedRows?.length > 1) {
        return this.$message.warning("请勾选一条单据进行操作")
      }
      if(this.selectedRows[0].diffFlag !== '1') {
        return this.$message.warning("请选择“与PBOM差异”为是数据")
      }
      this.$refs.differenceModalRef.show(this.selectedRows[0])
    },
    // 批量差异处理
    onBatchDifference() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      const invalidRows = this.selectedRows.filter(item => item.diffFlag !== '1')
      if(invalidRows.length > 0) {
        return this.$message.warning("请选择所有“与PBOM差异”都为是的数据")
      }
      this.$refs.batchDifferenceModalRef.show(this.selectedRows)
    },
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    onSearch(value = {}, changePage = false) {
      const params = Object.assign({
        diffFlag: "1",
        effectiveFlag: "Y"
      }, this.queryParams, value)
      this.onChangeCopyFormExcel(params, 'itemCode', 'itemCodes')
      delete params.searchFormLabel
      if(params?.itemCodes?.length === 1) {
        delete params.itemCodes
      }else {
        delete params.itemCode
      }
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    resetQuery() {
      this.queryParams = {}
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    }
  }
}
</script>

<style scoped lang="less">
.item-code-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.expand-toggle-icon {
  color: #1890ff;
  cursor: pointer;
}

/deep/.manufacture-search-form .ant-col:nth-last-child(3) {
  .ant-form-item{
    .ant-form-item-label{
      width: 160px !important;
    }
    .ant-form-item-control-wrapper{
      max-width: 230px !important;
    }
  }
}
</style>
